








































import { computed, defineComponent, onMounted, ref, watch } from '@vue/composition-api';
import MyDonationModule from '@/components/my-donation-module/index.vue';
import HonoraryModule from '@/components/honorary-module/index.vue';
import { getHonoraryInfo } from '@/hooks/use-honorary';
import { useStampStore } from '@/store/stamp';
import { storeToRefs } from 'pinia';
import { useRoute } from '@/hooks/use-route';
import { language } from '@tencent/ppd-base-libs';
import SavePicture from '@/components/common/save-picture/index.vue';
import { hideLoading, showErrorDialog, showLoading } from '@tencent/wphk-act-base-ui';
import { i18n } from '@/i18n';
import { biBrow } from '@tencent/fit-bi-sdk';

export default defineComponent({
  name: 'Donation',
  components: {
    MyDonationModule,
    HonoraryModule,
    SavePicture,
  },
  setup() {
    const stampStore = useStampStore();
    const { userStampInfo, ngoActInfoList } = storeToRefs(stampStore);

    // 用户捐贈数量
    const usedCnt = computed(() => userStampInfo.value.usedCnt);

    // 用户等级信息
    const info = computed(() => getHonoraryInfo(usedCnt.value));

    const isShowStampDetail = ref(true);

    // 处理返回
    const route = useRoute();
    const goHome = () => {
      route.router.replace('/');
    };

    // 每次进入捐贈详情之前，判断当前用户是否有捐贈过印花，如果没有则返回首页
    onMounted(() => {
      console.log('userStampInfo.value.usedCnt', usedCnt.value);
      if (!usedCnt.value) goHome();
      biBrow('my-donation.page_brow|我的捐赠曝光');
    });
    watch(usedCnt, () => {
      if (!usedCnt.value) goHome();
    });

    const donationRecordContent = computed(() => (isShowStampDetail.value ? i18n('累計捐贈x個公益印花', { usedCnt: userStampInfo.value.usedCnt }) : i18n('一起用愛點亮希望～')));

    // 语言
    const isEn = ref(false);
    isEn.value = language.isEn();
    const savePicture = ref<InstanceType<typeof SavePicture> | null>(null);
    return {
      donationRecordContent,
      userStampInfo,
      ngoActInfoList,
      savePicture,
      isShowStampDetail,
      userLevel: info.value?.nickName || '',
      handleSavePic(el: HTMLElement, cb: () => void) {
        showLoading();
        document.documentElement.scrollTop = 0;
        setTimeout(() => {
          savePicture.value
            ?.draw(el)
            .catch(() => {
              showErrorDialog({ message: i18n('圖片保存失敗') });
            })
            .finally(() => {
              hideLoading();
              cb();
            });
        }, 0);
      },
      handleSavePicShow() {
        console.log('图片已经生成，展示图片浮动层');
      },
      showHideDetail(isShow) {
        isShowStampDetail.value = isShow;
      },
      isEn,
    };
  },
});
